module.exports = __webpack_public_path__ + "img/vgjc.7c001233.png";